const ENGAGE_ACTIVITY_TYPES = ['event', 'content'];

const sumPoints = items => (items ?? []).reduce((sum, item) => sum + item.points, 0);

const countWhere = (items, predicate) => (items ?? []).filter(predicate).length;

const pluralizePoints = count => `${count} point${count === 1 ? '' : 's'}`;

export const isEngagementActivity = item => ENGAGE_ACTIVITY_TYPES.includes(item.activity_type);

export const isBonusActivity = item => !isEngagementActivity(item);

export const eventsAndContent = bonusPoints =>
  sumPoints((bonusPoints ?? []).filter(isEngagementActivity));

export const bonusPointsTotal = bonusPoints =>
  sumPoints((bonusPoints ?? []).filter(isBonusActivity));

export const mergedMergeRequests = (mrs, scoring) => {
  const total = (mrs ?? []).length * (scoring?.merged_mr_author_points ?? 0);
  const linked = countWhere(mrs, mr => mr.has_linked_issue);

  return total + (linked * (scoring?.merged_mr_with_issue_points ?? 0));
};

export const openedMergeRequests = (mrs, scoring) =>
  (mrs ?? []).length * (scoring?.created_mr_author_points ?? 0);

export const mergedCommits = (commits, scoring) => {
  const uniqueMrs = new Set((commits ?? []).map(c => c.merge_request_web_url));

  return uniqueMrs.size * (scoring?.merged_mr_committer_points ?? 0);
};

export const openedIssues = (issues, scoring) =>
  (issues ?? []).length * (scoring?.created_issue_points ?? 0);

export const addedNotes = (notes, scoring) =>
  (notes ?? []).length * (scoring?.note_points ?? 0);

export const translations = items => sumPoints(items);

export const discordMessages = (messages, scoring) => {
  const replies = countWhere(messages, m => m.reply);
  const base = (messages ?? []).length - replies;

  return (base * (scoring?.discord_message_points ?? 0))
    + (replies * (scoring?.discord_reply_points ?? 0));
};

export const forumPosts = (posts, scoring) => {
  const replies = countWhere(posts, p => p.reply);
  const base = (posts ?? []).length - replies;

  return (base * (scoring?.forum_post_points ?? 0))
    + (replies * (scoring?.forum_reply_points ?? 0));
};

export const descriptions = (scoring) => {
  if (!scoring) {
    return {};
  }

  return {
    mergedMergeRequests:
      `${pluralizePoints(scoring.merged_mr_author_points)} per merge request; `
      + `additional ${pluralizePoints(scoring.merged_mr_with_issue_points)} if linked to an issue.`,
    openedMergeRequests:
      `${pluralizePoints(scoring.created_mr_author_points)} per merge request.`,
    mergedCommits:
      `${pluralizePoints(scoring.merged_mr_committer_points)} per unique merge request you've committed to.`,
    openedIssues:
      `${pluralizePoints(scoring.created_issue_points)} per issue.`,
    addedNotes:
      `${pluralizePoints(scoring.note_points)} per comment.`,
    discordMessages:
      `${pluralizePoints(scoring.discord_message_points)} per message; `
      + `${pluralizePoints(scoring.discord_reply_points)} per reply.`,
    forumPosts:
      `${pluralizePoints(scoring.forum_post_points)} per post; `
      + `${pluralizePoints(scoring.forum_reply_points)} per reply.`,
  };
};
